// web-ctr/src/lib/auth.js
// School session held in a cookie on the PARENT domain (.clearedto.rent) so
// one sign-in follows a multi-location operator across school subdomains
// (localStorage is per-origin and would strand the session on one host).
// The cookie value is OUR signed JWT from /api/ctr/auth/verify; no Supabase
// key of any kind ships in this bundle, deliberately (see
// services/ctr-auth.service.js header).
import { ApiError } from '@/lib/api.js';

const COOKIE = 'ctr_session';
const MAX_AGE = 30 * 24 * 3600;

function cookieDomain() {
  const host = window.location.hostname.toLowerCase();
  if (host === 'clearedto.rent' || host.endsWith('.clearedto.rent')) return '.clearedto.rent';
  return null; // dev: host-only cookie
}

export function sessionToken() {
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE}=([^;]+)`));
  return m ? decodeURIComponent(m[1]) : null;
}

export function setSessionToken(token) {
  const domain = cookieDomain();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=${encodeURIComponent(token)}; Path=/; Max-Age=${MAX_AGE}${domain ? `; Domain=${domain}` : ''}; SameSite=Lax${secure}`;
}

export function clearSession() {
  const domain = cookieDomain();
  document.cookie = `${COOKIE}=; Path=/; Max-Age=0${domain ? `; Domain=${domain}` : ''}`;
}

async function call(path, options = {}) {
  const token = sessionToken();
  const res = await fetch(path, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(body.code || body.error || `http_${res.status}`, res.status, body);
  return body;
}

export const authApi = {
  get: (path) => call(path),
  post: (path, body) => call(path, { method: 'POST', body: JSON.stringify(body) }),
  patch: (path, body) => call(path, { method: 'PATCH', body: JSON.stringify(body) }),
  del: (path) => call(path, { method: 'DELETE' }),
};

/** Where a membership's dashboard lives. Production is cross-subdomain; dev
 *  keeps the ?school= override. */
export function dashboardUrlFor(slug) {
  const host = window.location.hostname.toLowerCase();
  if (host === 'clearedto.rent' || host.endsWith('.clearedto.rent')) {
    return `https://${slug}.clearedto.rent/dashboard`;
  }
  return `/dashboard?school=${encodeURIComponent(slug)}`;
}
